import { render, staticRenderFns } from "./DocumentZoom.vue?vue&type=template&id=a707a3ee&"
import script from "./DocumentZoom.vue?vue&type=script&lang=js&"
export * from "./DocumentZoom.vue?vue&type=script&lang=js&"
import style0 from "./DocumentZoom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports